export { default as Image } from '@/components/ui/Image/Image';
